<template>
  <div class="main-menu">
    <div class="menu-item" v-for="item in menuArray" :key="item" :class="selectMenu===item?'menu-select':''" @click="menuSelect(item)">
      <div class="item-view"  :class="selectMenu===item?'item-select':''">{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainmenu',
  props: {
    menuArray: Array,
    selectMenu: ''
  },
  methods: {
    menuSelect (item) {
      this.$emit('changeMenu', item)
    }
  }
}
</script>

<style scoped>
  .main-menu{
    width: 100%;
    height: 5rem;
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    top:0;
    left: 0;
    background-color: #252424;
  }
  .menu-item{
    width: 10rem;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;

  }
  .menu-select{
    background-color: white;
    /*box-shadow:0.38rem 0.38rem 0.38rem rgba(0,0,0,0.16);*/
  }
  .item-view{
    font-size:1.25rem;
    font-weight:bold;
    line-height:1.63rem;
    color:rgba(255,255,255,1);
    cursor: pointer;
  }
  .item-view:hover{
    transform: scale(1.05);
  }
  .item-select{
    font-size:1.25rem;
    font-weight:bold;
    line-height:1.63rem;
    color:rgba(89,89,89,1);
    user-select: none;
    cursor:default;
  }
  .item-select:hover{
    transform: scale(1);
  }
</style>



// WEBPACK FOOTER //
// src/components/mainmenu.vue